import * as ko from 'knockout';
import { ServerRequestComponent } from './server-request-component';

namespace PasswordReset
{
    export class PasswordResetViewModel extends ServerRequestComponent {
        SEND_REQUEST_URL = '/api/order/trial';

        constructor() {
            super();
        }

        email: KnockoutObservable<string> = ko.observable<string>();

        createRequest() {
            return { email: this.email};
        }

        resetPassword(e) {
            this.doRequest(e);
            return false;
        }
    }
}

export default function createTrialOrderRequestComponent(element: HTMLElement) {
    var viewModel = new PasswordReset.PasswordResetViewModel();
    ko.applyBindings(viewModel, element);
}

window['createTrialOrderRequestComponent'] = createTrialOrderRequestComponent;